import ScrollToTop from 'react-scroll-up';
import './ScrollUp.scss';

export const ScrollUp = () => (
  <div className='scroll-up'>
    <ScrollToTop
      showUnder={160}
      style={{
        /* Let CSS adjust button location */
        bottom: 'revert-layer',
        right: 'revert-layer',
      }}
    >
      <i className='fa fa-angle-up'></i>
    </ScrollToTop>
  </div>
);
